<template>
    <div>
        <v-card
                color="grey lighten-4"
                flat
                min-width="350px"
        >
            <v-toolbar
                    class="py-2"
                    color="primary"
                    dark
            >
                <v-toolbar-title v-html="event.title"></v-toolbar-title>
            </v-toolbar>
            <v-list>
                <a target="_blank" v-bind:href="'https://www.google.com/maps/search/?api=1&query='+address"
                   v-if="address">
                    <v-list-tile>
                        <v-list-tile-avatar>
                            <v-icon>place</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-title>{{address}}</v-list-tile-title>
                    </v-list-tile>
                </a>

                <v-list-tile>
                    <v-list-tile-avatar>
                        <v-icon>date_range</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>{{date}}</v-list-tile-title>
                </v-list-tile>

                <v-list-tile>
                    <v-list-tile-avatar>
                        <v-icon>access_time</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>{{event.arrangement.work_start_time}} ～ {{event.arrangement.work_end_time}}
                    </v-list-tile-title>
                </v-list-tile>

                <v-list-tile v-if="train_station">
                    <v-list-tile-avatar>
                        <v-icon>train</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>{{train_station}}</v-list-tile-title>
                </v-list-tile>

                <v-list-tile v-if="bus_stop">
                    <v-list-tile-avatar>
                        <v-icon>directions_bus</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>{{bus_stop}}</v-list-tile-title>
                </v-list-tile>

                <v-list-tile>
                    <v-list-tile-avatar>
                        <v-icon>check_box</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-title>
                        勤怠：{{getEnumDescription('Arrangement\\AttendanceType',event.arrangement_frame.attendance_type)}}
                    </v-list-tile-title>
                </v-list-tile>

            </v-list>
            <v-card-actions>
                <template v-if="event.displayUploadCompletionReports">
                    <upload-completion-reports
                        :arrangement="this.event.arrangement"
                        :arrangement_frame="this.event.arrangement_frame"
                        :branch="this.event.arrangement.branch"
                        :corporate="this.event.arrangement.corporate"
                        :date="this.event.arrangement.date"
                        :default_completion_report="this.event.completion_report"
                        :site="this.event.site"
                        title="完了届提出"
                        @updateCompletionReport="setCompletionReport"
                    ></upload-completion-reports>
                </template>
                <template v-if="!event.displayUploadCompletionReports">
                    <p style="color:red">
                        終了時刻の日付に完了届を提出してください。
                    </p>
                </template>
            </v-card-actions>
            <template v-if="event.arrangement_frame.attendance_type == '01'">
                <v-card-actions>
                    <v-btn @click="changeWork" color="success">出勤報告</v-btn>
                </v-card-actions>
            </template>
        </v-card>
    </div>
</template>

<script>
import {EnumsMixin} from "../../../mixins/enums";

export default {
  name: "FrontArrangementPopupComponent",
  mixins: [
    EnumsMixin,
  ],
  props: {
    event: Object,
  },
  computed: {
    date: function () {
      let date = moment(this.event.arrangement.date);
                return date.format('YYYY-MM-DD');
            },
            address: function () {
                // 現場を取得
                let site = this.event.site;

                // 住所を取得
                let prefecture = this.getEnumDescription('Common\\PrefectureType', site.prefecture_type);
                let city = site.city;
                let address1 = site.address_1;
                let address2 = site.address_2;
                let address = '';
                if (prefecture) {
                    address = address + prefecture;
                }
                if (city) {
                    address = address + city;
                }
                if (address1) {
                    address = address + address1;
                }
                if (address2) {
                    address = address + address2;
                }
                return address;
            },
            train_station: function () {
                // 現場を取得
                let site = this.event.site;

                // 最寄駅
                let stationRoute = site.nearest_station_route;
                let stationName = site.nearest_station_name;
                let trainStation = '';
                if (stationRoute) {
                    trainStation = trainStation + stationRoute;
                }
                if (stationName) {
                    trainStation = trainStation + stationName;
                }

                return trainStation;
            },
            bus_stop: function () {
                // 現場を取得
                let site = this.event.site;

                // 最寄バス停
                let busRoute = site.nearest_bus_route;
                let busName = site.nearest_bus_station_name;
                let busStop = busRoute + busName;
                if (busRoute) {
                    busStop = busStop + busRoute;
                }
                if (busName) {
                    busStop = busStop + busName;
                }
                return busStop;
            },
        },
        methods: {
            setCompletionReport: function (completionReport) {
                this.event.completion_report = completionReport;
                this.$emit('updateEventCompletionReport', this.event);
            },
            changeWork: function () {
                // パラメータ設定
                let authUserId = this.$store.state.auth.id;
                let param = {
                    'arrangement': this.event.arrangement,
                    'arrangement_frame': this.event.arrangement_frame,
                    'staff': {
                        'id': authUserId
                    }
                };

                // 更新処理
                let seqId = this.$root.startApiRequest();
                let url = 'api/arrangementExperiences/arrangementExperience/changeWork';
                appUtil.postAction(url, param)
                    .then(response => {
                        this.event.arrangement_frame = response.data.arrangementFrame;
                        appUtil.showInfoTimerDialog('出勤報告完了！', '本日もよろしくお願いします！');
                    })
                    .catch(response => {
                        if (response.response.data.message) {
                            let message = response.response.data.message;
                            appUtil.showErrorDialog('出勤報告エラー', message);
                        } else {
                            appUtil.showErrorDialog('出勤報告エラー', '想定外のエラーが発生しました。画面を再読み込みしてください。');
                        }
                    })
                    .finally(() => {
                        this.$root.endApiRequest(seqId);
                    });
            }
        }
    }
</script>

<style scoped>
    .v-toolbar__title {
        white-space: normal !important;
    }
</style>